import { Button, Tab } from '@material-ui/core';
import { Settings } from '@material-ui/icons';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getInfosAccount, getInfosSchool } from '@webapps/business';
import { useAuth, useQuery, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Account from 'components/AccountSettings/Account';
import Subscription from 'components/AccountSettings/Subscription';
import SchoolContract from 'components/AccountSettings/SchoolContract';
import { useEffect, useState } from 'react';

const SettingsSchool = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [value, setValue] = useState('1');
  const { addToast } = useToast();

  useEffect(() => {
    location.search.includes('payment=success') && setValue('2');
    if (location.search.includes('subscribe=true')) {
      setValue('2');
    }
  }, []);

  const { idUser } = useAuth();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: accountInfos = [], refetch: refetchAccountInfo } = useQuery(
    getInfosAccount,
    {
      key: 'accountInfos',
      variables: { id: idUser },
    }
  );

  const { data: infosVitrine = {}, refetch: refetchInfo } = useQuery(
    getInfosSchool,
    {
      key: 'schoolInfosVitrine',
      variables: { id: idUser },
      keepPreviousData: true,
    }
  );

  return (
    <div className={classes.container}>
      <div className={classes.paper} square>
        <TabContext value={value}>
          <TabList
            className={css({
              paddingLeft: spacing(0),
            })}
            indicatorColor="default"
            onChange={handleChange}
          >
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  width: '50%',
                }),
              }}
              className={global.mainTitle}
              label="Compte"
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  width: '50%',
                }),
              }}
              className={global.mainTitle}
              label="Abonnements"
              value="2"
            />
          </TabList>
          <div>
            <TabPanel className={css({ padding: spacing(0) })} value="1">
              <Account
                accountInfos={accountInfos}
                refetchAccountInfo={refetchAccountInfo}
              />
              <SchoolContract infosVitrine={infosVitrine} refetchInfo={refetchInfo} />
            </TabPanel>
            <TabPanel className={css({ padding: spacing(0) })} value="2">
              <Subscription
                accountInfos={accountInfos}
                refetchAccountInfo={refetchAccountInfo}
              />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    lineHeight: '110%',
        padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    '@media (max-width:768px)': { padding: '20px' },
  },
  paper: {
    flex: '1 1 0px',
    borderRadius: 10,
  },
  btnLogoutContainer: {
    marginTop: 'auto',
    margin: spacing(1),
    height: 45,
    display: 'flex',
    justifyContent: 'center',
  },
  containerTabPanel: {
    margin: 0,
    padding: 0,
  },
});

export default SettingsSchool;
